import React from 'react';
import VoucherAmountFields from './VoucherAmountFields';

// POS presentation: a BOTTOM SHEET that slides up from the bottom — full-width
// on mobile (proper slide-up), a centred sheet on desktop. The diary checkout
// uses the inline step instead (VoucherAmountFields directly), so this is the
// POS surface only.

export default function VoucherAmountPicker({ voucher, currency = '£', onConfirm, onClose }) {
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 4000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
      <style>{`@keyframes vapSlideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}`}</style>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: '18px 18px 0 0',
          width: '100%',
          maxWidth: 480,
          padding: '20px 22px calc(22px + env(safe-area-inset-bottom, 0px))',
          boxShadow: '0 -6px 30px rgba(0,0,0,0.18)',
          maxHeight: '88%',
          overflowY: 'auto',
          animation: 'vapSlideUp 0.22s cubic-bezier(0.32,0.72,0,1)',
        }}
      >
        <div style={{ width: 36, height: 4, borderRadius: 2, background: '#E0E0E4', margin: '0 auto 14px' }} />
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 4 }}>
          <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: 0 }}>{voucher.name || 'Gift voucher'}</h2>
          <button onClick={onClose} aria-label="Close" style={{ background: 'none', border: 'none', fontSize: 22, lineHeight: 1, color: '#8e8e93', cursor: 'pointer', padding: 0 }}>×</button>
        </div>
        <VoucherAmountFields voucher={voucher} currency={currency} onConfirm={onConfirm} />
      </div>
    </div>
  );
}
